import React from "react";

const Dashboard = () => {
  return (
    <>
      <h1 className="h3 mb-4 text-gray-800">Dashboard</h1>
      <p>Đây là trang tổng quan.</p>
    </>
  );
};

export default Dashboard;
